import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import { FlexColumn } from '../../../styled/Flex';

interface FieldProps {
  field: string;
  label: string;
  placeholder: string;
  value?: string | number | null;
  touched?: boolean | null;
  error?: string | null;
  disabled?: boolean;
  type?: string;
  handleChange: (e: string | ChangeEvent) => void;
  handleBlur: (e: string | ChangeEvent) => void;
  multiline?: boolean;
  rows?: number;
  decimalPlaces?: number;
}

const CrudStringField = (props: FieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleNumberChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (props.type === 'number' && props.decimalPlaces !== undefined) {
      const { value } = e.target;

      if (value === '') {
        props.handleChange(e);
        return;
      }

      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length > props.decimalPlaces) {
          return;
        }
      }
    }

    props.handleChange(e);
  };

  return (
    <FlexColumn width="100%">
      <InputLabel sx={{ paddingBottom: 1 }} data-automation={`${props.field}-title`}>
        {props.label}
      </InputLabel>
      <FormControl fullWidth>
        <OutlinedInput
          id={props.field}
          name={props.field}
          placeholder={props.placeholder}
          type={showPassword ? 'text' : props.type}
          fullWidth
          autoComplete="off"
          value={props.value}
          // error={props.error ? true : false}
          onChange={handleNumberChange}
          onBlur={props.handleBlur}
          disabled={props.disabled}
          multiline={props.multiline ? true : false}
          rows={props.rows ? props.rows : 1}
          sx={{
            height: props.multiline ? `${props.rows ? props.rows * 3 : 5}rem` : '5rem',
            '.MuiInputBase-input': {
              WebkitBoxShadow: '0 0 0 30px white inset !important',
            },
          }}
          endAdornment={
            <>
              {props.type === 'password' && (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <Visibility /> : <VisibilityOff />}</IconButton>
                </InputAdornment>
              )}
            </>
          }
        />
      </FormControl>
      {props.touched && props.error ? (
        <FormHelperText error data-automation={`error-${props.field}`}>
          {props.error}
        </FormHelperText>
      ) : null}
    </FlexColumn>
  );
};

export default CrudStringField;
